export default __webpack_public_path__ + "static/2-map-1811314792a84608722dff058ef0f220.jpg";